import React from 'react';
import styles from './App.module.css';
import './App.css';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from "react-router-dom";

import AppHeader from '../AppHeader/AppHeader';
import AppFooter from '../AppFooter/AppFooter';
import MainPage from '../../pages/Main/MainPage';
import SelectionPage from '../../pages/Selection/SelectionPage';
import ContactsPage from '../../pages/Contacts/ContactsPage';

//Разделил компонент App на два компонента: Layout и App. Т.к. location нельзя использовать в App  напрямую
function Layout() {
  const location = useLocation();

  return (
    <div className={styles.app}>
      <AppHeader />
      <main className={styles.main}>
        <Routes>
          <Route path='/' element={<MainPage />} />
          <Route path='/подбор' element={<SelectionPage />} />
          <Route path='/контакты' element={<ContactsPage />} />
          {/* Переадресация с несуществующих роутов */}
          <Route path="*" element={<Navigate to="/" />} /> 
        </Routes>
      </main>
      {decodeURIComponent(location.pathname) !== "/контакты" && <AppFooter />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;
